import * as driversActions from '../actions/drivers.actions';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { DriverApiModel } from 'app/models/drivers-api.model';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  drivers: DriverApiModel[];
  isLoading: boolean;
  isReady: boolean;
  totalDrivers: number;
  isSaving: boolean;
}

export const initialState: State = {
  drivers: [],
  isLoading: false,
  isReady: false,
  totalDrivers: 0,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(driversActions.loadDrivers, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(driversActions.loadDriversSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    drivers: response.results,
    totalDrivers: response.count ? response.count : response.results.length,
  })),
  on(driversActions.createDriver, driversActions.updateDriver, (state) => ({
    ...state,
    isSaving: true,
  })),
  on(
    driversActions.createDriverSuccess,
    driversActions.createDriverFailed,
    driversActions.updateDriverSuccess,
    driversActions.updateDriverFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    driversActions.resetDrivers,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
